import { useReducer, useRef, useEffect } from 'react';
import TextInput from '../TextInput';
import { checkDecimals, formatPercentages } from '../../helpers';
import Button from '../Button';
import ClickAwayListener from 'react-click-away-listener';

type LeverageInputProps = {
    leverage: string;
    maxLeverage: number;
    disabled?: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const LeverageInput: React.FC<LeverageInputProps> = ({
    leverage,
    maxLeverage,
    disabled = false,
    onChange,
}) => {
    const [editable, toggleEditable] = useReducer((prev) => !prev, false);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (editable) {
            inputRef.current?.focus();
        }
    }, [editable]);

    return (
        <ClickAwayListener onClickAway={editable ? toggleEditable : () => {}}>
            <div className='leverage-input-container'>
                {editable ? (
                    <div className='input-container'>
                        <TextInput
                            ref={inputRef}
                            name='leverage'
                            max={100}
                            value={leverage}
                            onChange={onChange}
                            onClick={(event) => event.stopPropagation()}
                            validate={(leverage) =>
                                (Number(leverage) <= maxLeverage &&
                                    Number(leverage) > 0 &&
                                    checkDecimals(leverage, 1)) ||
                                leverage === ''
                            }
                            readOnly={!editable}
                            tabIndex={editable && !disabled ? 0 : -1}
                            placeholder='0.0'
                            disabled={disabled}
                        />
                        <span>x</span>
                    </div>
                ) : (
                    <Button
                        variant='transparent'
                        onClick={toggleEditable}
                        disabled={disabled}
                        className='leverage-value'
                    >{`${formatPercentages(leverage || '0')}x`}</Button>
                )}
            </div>
        </ClickAwayListener>
    );
};

export default LeverageInput;
